export default (value = "") => {
  const num = value ? value.replace(/\D/g, "") : "";
  return num.length > 9;
};
